/* jshint esversion: 6 */
import React from 'react';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import InputTextRule from 'app/components/EditorComponents/InputTextRule.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import _ from 'underscore';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import { Link } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputTextPanel extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			canAddRule: true
		};

		this.addRule = this.addRule.bind(this);

	}

	addRule(e) {
		e.preventDefault();
		this.props.textRuleHandler('add');
	}

	render() {
		let prefixText = (this.props.input.attrs) ? this.props.input.attrs.prefixText : '',
			prefixSpace = (this.props.input.attrs && parseInt(this.props.input.attrs.prefixSpace, 10)) ? true : false,
			postfixText = (this.props.input.attrs) ? this.props.input.attrs.postfixText : '',
			postfixSpace = (this.props.input.attrs && parseInt(this.props.input.attrs.postfixSpace, 10)) ? true : false,
			rules = (this.props.input.rules) ? this.props.input.rules : [],
			ruleset = null,
			ruleButton = null,
			hashtagPath = location.pathname.replace('text', 'hashtags');


		ruleset = rules.map(function(rule, i){
			if (!rule.deleted) {
				return (
					<InputTextRule rule={rule} key={i} textRuleHandler={this.props.textRuleHandler} ruleId={i} errors={this.props.errors} />
				);
			}
		}, this);

		if (this.state.canAddRule) {
			ruleButton = <button className="btn-secondary" onClick={this.addRule}>Add Rule</button>;
		}

		return (
			<div className="editor-panel">
				<form>
					<fieldset>
						<legend>Prefix<HelpButton which="prefixSuffix"/></legend>
						<ErrorModule
	                        app={this.props.app}
	                        keys={['INPUT_CREATE', 'INPUT_UPDATE']}
	                        render={(state) => {
	                            return (
	                                <FieldError field="attrs.prefixText" errors={state.errors}/>
	                            );
	                        }}/>
						<ErrorModule
	                        app={this.props.app}
	                        keys={['INPUT_CREATE', 'INPUT_UPDATE']}
	                        render={(state) => {
	                            return (
	                                <FieldError field="attrs.prefixSpace" errors={state.errors}/>
	                            );
	                        }}/>
						<div className="text-insert-rule">
							<div>
								<UncontrolledTextInput
									className="text-input medium"
									placeholder="Start items with"
									defaultValue={prefixText}
									onChange={this.props.changeHandler}
									data-field={this.props.statePath + ".attrs.prefixText"}/>
								<p className='help-text hashtag'>
									Prefixes may not contain '#'. <Link to={hashtagPath}>Need hashtags?</Link>
								</p>
							</div>
							<div className="toggle-right">
								<Toggle
									active={prefixSpace}
									activeLabel="Disable space after prefix"
									inactiveLabel="Disable space after prefix"
									callback={this.props.changeHandler}
									linkedField={this.props.statePath + ".attrs.prefixSpace"} />
							</div>
						</div>
					</fieldset>
					<fieldset>
						<legend>Suffix<HelpButton which="prefixSuffix"/></legend>
						<ErrorModule
	                        app={this.props.app}
	                        keys={['INPUT_CREATE', 'INPUT_UPDATE']}
	                        render={(state) => {
	                            return (
	                                <FieldError field="attrs.postfixText" errors={state.errors}/>
	                            );
	                        }}/>
						<ErrorModule
	                        app={this.props.app}
	                        keys={['INPUT_CREATE', 'INPUT_UPDATE']}
	                        render={(state) => {
	                            return (
	                                <FieldError field="attrs.postfixSpace" errors={state.errors}/>
	                            );
	                        }}/>
						<div className="text-insert-rule">
							<div>
								<UncontrolledTextInput
									className="text-input medium"
									placeholder="End items with"
									defaultValue={postfixText}
									onChange={this.props.changeHandler}
									data-field={this.props.statePath + ".attrs.postfixText"}/>
								<p className='help-text hashtag'>
									Suffixes may not contain '#'. <Link to={hashtagPath}>Need hashtags?</Link>
								</p>
							</div>
							<div className="toggle-right">
								<Toggle
									active={postfixSpace}
									activeLabel="Disable space before suffix"
									inactiveLabel="Disable space before suffix"
									callback={this.props.changeHandler}
									linkedField={this.props.statePath + ".attrs.postfixSpace"} />
							</div>
						</div>
					</fieldset>
					<fieldset>
						<legend>Find and Replace / Remove<HelpButton which="searchReplace"/></legend>
						<ErrorModule
	                        app={this.props.app}
	                        keys={['INPUT_CREATE', 'INPUT_UPDATE']}
	                        render={(state) => {
	                            return (
	                                <FieldError field="rules" options={{isString: true}} errors={state.errors}/>
	                            );
	                        }}/>
						{ruleset}
						{ruleButton}
					</fieldset>
				</form>
			</div>
		);
	}
};

InputTextPanel.displayName = "InputTextPanel";

export default ComponentWithContext(InputTextPanel);
